// extracted by mini-css-extract-plugin
export default {"spanMarcador":"tableBodyReportService_spanMarcador__oK--q"};